module.exports = __webpack_public_path__ + "assets/5cbf33f4f0f002f20e32276caa8d8ef2.mp3";